import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';

import WDT_STUDENT_OVERALL_PROGRESS_QUERY from 'graph/reports/wdt-student-overall-progress-report-query';
import CharactersAndTimeSpentChart from '../../common/CharactersAndTimeSpentChart';
import ActivitiesCompletedCharacterCard from './ActivitiesCompletedCharacterCard';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import StudentSettingsCard from './StudentSettingsCard';
import { ModuleType } from '../../../../types';
import { WdtStudentModuleProgressData } from 'types/schema-generated-types';
import { getQueryVariables } from '../../../../utils/report-param-utils';

const StudentOverrallCards: React.FC = () => {
  const [{ dateRange, entityType, entityId }] = useReportQueryParams();
  const [fetchOverallProgressReport, { data, loading }] = useLazyQuery(
    WDT_STUDENT_OVERALL_PROGRESS_QUERY
  );

  const reportData: WdtStudentModuleProgressData[] =
    data?.wdtStudentOverallProgressReport?.progress ?? [];

  useEffect(() => {
    fetchOverallProgressReport({
      variables: getQueryVariables({ entityId, entityType, dateRange })
    });
  }, [fetchOverallProgressReport, entityId, entityType, dateRange]);

  return (
    <section>
      <Grid container wrap="wrap" spacing={2}>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.CAPITALS}
            reportData={reportData}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.LOWERCASE}
            reportData={reportData}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <ActivitiesCompletedCharacterCard
            module={ModuleType.NUMBERS}
            reportData={reportData}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <StudentSettingsCard />
        </Grid>
        <Grid item xs={12}>
          <CharactersAndTimeSpentChart />
        </Grid>
      </Grid>
    </section>
  );
};

export default StudentOverrallCards;
